
export const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.1,
        ease: "easeInOut",
      },
    },
    exit: {
      transition: { duration: 0, delay: 0 },
    },
  };
  
  export const itemVariants = {
    hidden: { opacity: 0, y: 100 },
    visible: { opacity: 1, y: 0, transition: { duration: 1, ease: "easeInOut" } },
    exit: { opacity: 0, y: 20, transition: { duration: 0, delay: 0 } },
  };
  
  export const photoVariants = {
    initial: { scale: 1.2, transition: { duration: 3, ease: "easeInOut" } },
    whileInView: { scale: 1, transition: { duration: 3, ease: "easeInOut" } },
    exit: { scale: 1.2, transition: { duration: 0, delay: 0 } },
  };
  



  
  export const itemVariants2 = {
    hidden: { opacity: 0, y: 100 },
    whileInView: (custom) => ({
        opacity: 1,
        y: 0,
        transition: {
            duration: 1,
            ease: "easeInOut",
            delay: custom * 0.2, 
        },
    }),
    exit: { opacity: 0},
};

  export const photoVariants2 = {
    initial: { opacity: 0, scale: 1.2 },
    whileInView: (custom) => ({
        opacity: 1,
        scale: 1,
        transition: {
            duration: 1,
            ease: "easeInOut",
            delay: custom * 0.2, 
        },
    }),
    exit: { opacity: 0},
};

export const photoVariants3 = {
    initial: { opacity: 0, scale: 1.2 },
    whileInView: { 
        opacity: 1, 
        scale: 1,
        transition: {
            duration: 1,
            ease: "easeInOut",
        }
    },
    exit: { opacity: 0, scale: 1.2 },
};